import { useEffect } from 'react';
import { useBreadcrumbs } from './useBreadcrumbs';

/**
 * Registers breadcrumbs on mount and clears on unmount.
 * Accepts a breadcrumb array and a dependency array.
 * Cancels pending registration if component unmounts before completion.
 *
 * @param {import('../contexts/BreadcrumbContext').BreadcrumbSegment[]} segments - Breadcrumb trail to display
 * @param {Array} deps - Dependency array (re-registers when deps change)
 */
const usePageBreadcrumbs = (segments, deps = []) => {
  const { setBreadcrumbs, clearBreadcrumbs } = useBreadcrumbs();

  useEffect(() => {
    let cancelled = false;
    setBreadcrumbs(segments);
    return () => {
      cancelled = true;
      clearBreadcrumbs();
    };
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
};

export default usePageBreadcrumbs;
export { usePageBreadcrumbs };
